import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FormControl, MenuItem } from "@material-ui/core";
import { SelectValidator } from 'react-material-ui-form-validator';
import { fetchConToken } from "../../helpers/fetch";
import { fetchCentrosMedicosPropiosHabilitados, fetchCentrosMedicosPropiosPorUsuario } from "../../actions/centrosMedicosPropios";
import { armarParametros } from "../../helpers/parametros";

export const CboCentrosMedicos = (props) => {
  const dispatch = useDispatch();
  const [listaNac, setListaNac] = useState([]);
  const [labelShrink, setLabelShrink] = useState(false);
  const { cargarEnCascada, idEspecialidad, idProfesional, filtrarPorUsuario, porProfesional, cargaAfiliado, manejadorInputChange, valor, idCombo } = props;

  const { items, cargada } = useSelector(state => state.centrosMedicosPropios);

  useEffect(() => {
    if (cargarEnCascada) {
      const traerDatos = async () => {
        const parametros = armarParametros(idEspecialidad, null, idProfesional, null, null, null, null, null, filtrarPorUsuario);
        const response = porProfesional ? await fetchConToken(`CentrosMedicosPropios/traerPorProfesional?${parametros}`) : await fetchConToken(`CentrosMedicosPropios/traer?${parametros}`);
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (response.ok && lista) {
            let listaFromApi = lista.map((item) => {
              return {
                value: item.idCentroMedico,
                display: item.descripcionCentro,
              };
            });
            setListaNac(listaFromApi);
            if (lista.length === 1 && cargarEnCascada && !cargaAfiliado) {
              setLabelShrink(true);
              cargarEnCascada && manejadorInputChange({ target: { name: 'idCentroMedico', value: lista[0].idCentroMedico } });
            }
          }
        }
      };
      if ((idEspecialidad === null && !porProfesional) || (porProfesional && !idProfesional))
        setListaNac([]);
      else
        traerDatos();
    } else if (!cargada && filtrarPorUsuario) {
      dispatch(fetchCentrosMedicosPropiosPorUsuario());
    } else if (!cargada) {
      dispatch(fetchCentrosMedicosPropiosHabilitados());
    }
    // eslint-disable-next-line
  }, [dispatch, idEspecialidad, idProfesional, cargada, cargarEnCascada, filtrarPorUsuario, porProfesional, manejadorInputChange]);

  const inputChange = e => {
    manejadorInputChange(e);
    e.target.value ? setLabelShrink(true) : setLabelShrink(false);
  }

  return (
    <>
      {cargarEnCascada
        ?
        <FormControl
          margin="normal"
          fullWidth={true}
        >
          <SelectValidator
            onChange={(e) => {
              inputChange(e);
            }}
            label="Centro Médico"
            name="idCentroMedico"
            value={valor}
            fullWidth={true}
            validators={['required']}
            errorMessages={['Seleccione una opción']}
            InputLabelProps={{
              shrink: labelShrink,
            }}
          >
            <MenuItem value="">
              <em>Seleccione</em>
            </MenuItem>
            {listaNac.map((nac) =>
              <MenuItem key={nac.value} value={nac.value}>
                {nac.display}
              </MenuItem>
            )}
          </SelectValidator>
        </FormControl>
        :
        <FormControl
          margin="normal"
          name={idCombo}
          fullWidth={true}
        >
          <SelectValidator
            value={valor}
            onChange={manejadorInputChange}
            label="Centro Medico"
            name={idCombo}
            fullWidth={true}
            validators={props.required === undefined ? ['required'] : props.required}
            errorMessages={['Seleccione una opción']}
          >
            <MenuItem value={null}>
              <em>Seleccione</em>
            </MenuItem>
            {items.map((item) =>
              <MenuItem key={item.idCentroMedico} value={item.idCentroMedico}>
                {item.descripcionCentro}
              </MenuItem>
            )}
          </SelectValidator>
        </FormControl>
      }
    </>
  );
};
